export default __webpack_public_path__ + "static/media/1.0a2f0f08.png";